module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4ZWEzYTkzYzYxMjE0MGM2N2U4YjQxMzY4YzYzZWZkMy5zdmciOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./app/fonts/flaticon.svg
 ** module id = 31
 ** module chunks = 0
 **/